








































import { Component, Vue } from 'vue-property-decorator'
import * as ui from '@/types/frontend'
import { Button, Card, ProjectCard, ProjectCardData } from '@alpha/ink'
import IndexView from '@/components/IndexView.vue'
import FilterBar, { normalizeSearchTerm } from '@/components/FilterBar.vue'
import AddProjectModal from '@/components/AddProject/AddProjectModal.vue'
import store, { NotFoundErrorMessage } from '@/store'
import { Route } from 'vue-router'
import { NextFunction } from 'express'

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteUpdate'
])

@Component({
  components: {
    Card,
    Button,
    ProjectCard,
    IndexView,
    FilterBar,
    AddProjectModal
  }
})
export default class ProjectIndex extends Vue {
  filter: ui.Filter<ProjectCardData> = {}
  showAddProjectModal = false

  async beforeRouteEnter (to: Route, from: Route, next: NextFunction) {
    next((vm: ProjectIndex) => {
      if (store.getters.workspace.projects === null) {
        vm.$store.dispatch('setErrorMessage', NotFoundErrorMessage)
      }
    })
  }

  async beforeRouteUpdate (to: Route, from: Route, next: NextFunction) {
    next((vm: ProjectIndex) => {
      if (store.getters.workspace.projects === null) {
        vm.$store.dispatch('setErrorMessage', NotFoundErrorMessage)
      }
    })
  }

  get projects (): ProjectCardData[] {
    const projects = store.getters.workspace.projects
    return projects
  }

  get filteredProjects () {
    const normalizedSearchTerm = this.filter.searchTerm && normalizeSearchTerm(this.filter.searchTerm)
    return this.projects.filter(project => {
      const matchesTerm = !normalizedSearchTerm ? true : project.title.toLowerCase().includes(normalizedSearchTerm)
      const matchesId = !this.filter.title ? true : this.filter.title === project.title
      return matchesTerm && matchesId
    })
  }

  updateFilter (newFilter: ui.Filter<ProjectCardData>) {
    this.filter = newFilter
  }

  reportsForProject (project: ProjectCardData): any[] {
    let reports: any[] = []
    const drops = store.state.workspace.projectMap[project.id].ids
    if (drops) {
      drops.forEach(drop => {
        const sharedReport = store.getters.workspace.sharedReportsTests[drop]
        if (sharedReport) {
          reports = reports.concat(sharedReport)
        }
      })
    }
    const projectReports = store.getters.workspace.sharedReportsProjects[project.id]
    if (projectReports) {
      reports = reports.concat(projectReports)
    }
    return reports
  }
}

